<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-uanl">
      <div class="container">
        <a class="navbar-brand" href="#">
          <img
            src="static/img/iconoasisteseguro.png"
            style="max-width: 40px;"
            alt=""
          />
          Asiste Seguro
        </a>
        <button
          :class="{ 'd-none': usuario.token == null }"
          id="button_menu"
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item mb-3" :class="{ 'd-none': usuario.token == null }">
              <a class="nav-link" href="" v-on:click.prevent="Ruta('Escanear')">
                Escanear Código
              </a>
            </li>
            <li class="nav-item mb-3" :class="{ 'd-none': usuario.token == null }">
              <a class="nav-link" href="" v-on:click.prevent="Ruta('Ingresar')">
                Ingresar Matricula ó Clave de empleado
              </a>
            </li>
            <li class="nav-item mb-3" :class="{ 'd-none': usuario.token == null }">
              <a class="nav-link" href="" v-on:click.prevent="Logout">
                Cerrar Sesión
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase.js";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  methods: {
    async Logout() {
      var response = await auth.signOut();
      this.logout();
      $("#button_menu").click();
    },
    Ruta(name) {
      this.$router.push({
        name: name,
        params: { escanear: name == "Escanear" ? true : false }
      });
      $("#button_menu").click();
    },
    ...mapActions(["ActualizarUsuario", "logout"])
  },
  computed: {
    ...mapState(["usuario"])
  },
  created() {
    auth.onAuthStateChanged(async user => {
      await this.ActualizarUsuario(false);
      if (user) {
        this.$router.push({ name: "Ingresar" });
      } else {
        this.$router.push({ name: "Login" });
      }
    });
  },
  mounted() {}
};
</script>

<style>
.bg-uanl {
  background: #004a8f !important;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue